import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import DossierDocuments from './DossierDocuments';
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class CostCenterEditForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            costCenter:[],
            active:true,
            targets:[],
            search:'',
            targets:[],
            name:'',
            users:[],
            selectedUsers:[],
            selectedUsersIds:[]
        };
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.displayUsers = this.displayUsers.bind(this)
        this.handleChangeName = this.handleChangeName.bind(this)
        this.handleTargetChanged = this.handleTargetChanged.bind(this)
        this.addUser = this.addUser.bind(this)
        this.getInitials = this.getInitials.bind(this)
    }

    async componentDidMount() {
        const { lang } = this.context; 
        await axios.get('/api/cost_centers/'+this.props.id).then(res=>{
            this.setState({ costCenter: res.data} );
            this.setState({ name: res.data.name} );
        })
        await this.getTargets()
        let selected = this.state.costCenter.user_cost_center.map((u)=>{
            u.user.userId = u.user.id
            return u
        })
        let selectedIds = this.state.costCenter.user_cost_center.map((u)=>{
            u.user.userId = u.user.id
            return u.user.id
        })
        this.setState({ selectedUsers: selected} );
        this.setState({ selectedUsersIds: selectedIds} );
        const btnPublish = document.getElementById('btnPublish');
        btnPublish.addEventListener('click', () => {
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    if (this.state.selectedUsers.length >= 0) {
                        this.save();
                    } else {
                        swal.fire({
                            text: lang.get('messages.debes_seleccionar_al_menos_un_usuario'),
                            icon: "info",
                            buttonsStyling: false,
                            confirmButtonText: "Aceptar",
                            customClass: {
                                confirmButton: "btn font-weight-bold btn-primary"
                            }
                        })
                    }
                }
            })
        });
        const fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                name: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.nombre_requerido')
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: lang.get('messages.el_nombre_debe_tener_una_longitud_minima_de_4')
                        },
                    }
                },
                targets: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.campo_requerido')
                        }
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });

        const closeDropdown = e =>{
            this.setState({ users: []});
        }
        document.body.addEventListener('click',closeDropdown)
        return ()=> document.body.removeEventListener('click',closeDropdown)
    }

    handleCheck(id){
        let checked = false;
        this.state.costCenter.cost_center_dossier_targets.map(function(dossierTarget){
            if(dossierTarget.dossier_target_id == id){
                checked = true
            }
            if(dossierTarget.id == id){
                checked = true
            }
        })
        return checked;
    }

    addUser(user){
        this.selectUser(user)
    }

    getInitials(name){
        const nameList = name.split(' ')
        return nameList.length >= 2 ? `${nameList[0][0]}${nameList[1][0]}` : nameList[0][0]
    }

    async displayUsers(){
        const URL =  `/api/users/search?display=all`
        const membersResponse = await axios.get(URL)
        this.setState({ users: membersResponse.data}, function () {});
        setTimeout(function(){
            this.setState({ users: []})
        }.bind(this), 10000);
    }

    async handleSearchChange(e){
        if(e.target.value != '' ){
            const URL =  `/api/users/search?search=${e.target.value}`
            const membersResponse = await axios.get(URL)
            this.setState({ users: membersResponse.data}, function () {
                //this.getUsers();
            });
        }else{
            this.setState({ users: []}, function () {
                //this.getUsers();
            });
        }

    }
    handleChangeName(e){
        this.setState({ name:e.target.value})
    }

    selectUser(user){
        let exist = this.state.selectedUsers.filter((u)=>{
            if(u.user.userId == user.userId){
                return u
            }
        })
        if(exist.length ==0){
            this.setState({ selectedUsers: [...this.state.selectedUsers,user] })
            this.setState({ selectedUsersIds: [...this.state.selectedUsersIds,user.userId] })
        }
        this.setState({ users: [] })
    }

    handleTargetChanged(e){
        const { lang } = this.context; 
        this.setState(prevState => {
            let costCenter = Object.assign({}, prevState.costCenter);
            if(e.target.checked == true){
                let mime = this.state.targets.filter(function( obj ) {
                    return obj.id == e.target.value;
                })
                let target = {
                    dossier_target_id:mime[0].id
                }
                costCenter.cost_center_dossier_targets.push(target);
            }else{
                if(costCenter.cost_center_dossier_targets.length == 1){
                    Swal.fire({
                        text: lang.get('messages.la_plantilla_de_documento_debe_tener_al_menos_1_tipo_de_formato'),
                        icon: "error",
                        buttonsStyling: false,
                        confirmButtonText: "Aceptar",
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        }
                    })
                    return false;
                }
                costCenter.cost_center_dossier_targets = costCenter.cost_center_dossier_targets.filter(function( obj ) {
                    return obj.dossier_target_id != e.target.value;
                });
            }
            return { costCenter };
        })
    }

    async getTargets() {
        const res = await axios.get('/api/dossiers/targets')
        this.setState({targets: res.data})
    }

    async save() {
        const { lang } = this.context; 
        window.blockUI(lang.get('messages.procesando')); 
        if (this.state.active) {
            KTUtil.btnWait(KTUtil.getById('btnPublish'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        } else {
            KTUtil.btnWait(KTUtil.getById('btnSave'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        }
        const params = JSON.stringify({
            selectedUsers: this.state.selectedUsersIds,
            targets: this.state.costCenter.cost_center_dossier_targets,
            peopleId: this.state.costCenter.people_id,
            name: this.state.name,
        })
        
        await axios.put(
            '/api/cost_centers/'+this.state.costCenter.id,
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: lang.get('messages.guardado'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/cost_centers';
            });
        }).catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        })
    }

    async delete(user) {
        let exist = this.state.selectedUsers.filter((u)=>{
            if(u.user.userId != user.userId){
                return user
            }
        })
        let exists = this.state.selectedUsersIds.filter((u)=>{
            if(u != user.userId){
                return u
            }
        }) 
        this.setState({ selectedUsersIds: exists })
        this.setState({ selectedUsers: exist })
    }

    render() {
        const { lang } = this.context; 
        return (
            <form id="frm">
                <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                    <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                        <div className="d-flex align-items-center flex-wrap mr-1">
                            <div className="d-flex align-items-baseline flex-wrap mr-5">
                                <h5 className="text-dark font-weight-bold my-1 mr-5">
                                    {lang.get('messages.editar_centro_de_costo')}
                                </h5>
                            </div>
                        </div>
                        {
                            this.props.dossier_id != null && <div className="d-flex align-items-center flex-wrap">
                                <a href={"/dossiers/new?d=" + this.props.dossier_id} className="btn btn-fixed btn-primary font-size-sm">Duplicar Expediente</a>
                            </div>
                        }
                    </div>
                </div>
                <div className="d-flex flex-column-fluid">
                    <div className="container">
                        <div className="card card-custom gutter-b">
                            <div className="card-body">
                                <div className="row justify-content-center text-left">
                                    <div className="col-sm-4 form-group">
                                        <label htmlFor="title" className="text-left">{lang.get('messages.nombre')}</label>
                                        <input id="title" type="text"  value={this.state.name}  onChange={this.handleChangeName} className="form-control form-control-solid" name="name"   required autoFocus  />
                                    </div>
                                    <div className="col-sm-8 form-group">
                                        <label htmlFor="dossier_targets_id " className="text-left">{lang.get('messages.centro_de_costos_para')}:</label>
                                        <div className="checkbox-inline">
                                            {   this.state.targets.map(( mime) => {
                                                return(
                                                    <label key={mime.id} className="checkbox checkbox-lg checkbox-square">
                                                        <input type="checkbox" name="extensions" value={mime.id} checked={this.handleCheck(mime.id,mime.name)}   onChange={ e => (this.handleTargetChanged(e)) }/>
                                                        <span></span>
                                                        {lang.get('messages.'+mime.name.toLowerCase())}
                                                    </label>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card card-custom gutter-b">
                            <div className="card-body">
                                <p className="font-weight-bold">{lang.get('messages.colaboradores_del_centro_de_costos')}</p>
                                <input id="title" type="text" onClick={()=>{this.displayUsers()}} placeholder="Buscar usuarios" className="form-control form-control-solid col-sm-4" name="title"  autoFocus onChange={this.handleSearchChange}/>
                                <div className="suggestions">
                                {this.state.users.map((u) => {
                                    return(
                                        <div key={u.userId} className="suggestion" onClick={()=>{this.addUser(u)}}>
                                            {u.name}
                                        </div>
                                    )
                                })}
                                </div>
                                <table className="mt-20 table table-borderless table-vertical-center">
                                    <thead>
                                        <tr className="b-bottom">
                                            <td colSpan="2">{lang.get('messages.usuario')}</td>
                                            <td>{lang.get('messages.perfil')}</td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.selectedUsers.map((u) => {
                                        return(
                                            <tr key={u.user.userId}>
                                                <td style={{width: '1%'}}>
                                                    <div className="symbol symbol-40">
                                                        <div className="symbol-label bg-primary-o-40 text-primary font-weight-bolder">
                                                            {this.getInitials(u.user.name)}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-dark-75 font-weight-bolder font-size-lg"> {u.user.name}</div>
                                                    <span className="text-dark-50 font-weight-bold font-size-sm"> {u.user.email}</span>
                                                </td>
                                                <td>
                                                    {u.profiles.map((p,i,arr) => {
                                                        if (arr.length - 1 === i) {
                                                            return p.people_profile.name
                                                        } else {
                                                            return p.people_profile.name + ', '
                                                        }
                                                    })}
                                                </td>
                                                <td className="text-right">
                                                <a onClick={()=>{ this.delete(u.user) }} className="btn btn-xs btn-icon btn-light-secondary mr-4"><i className="flaticon-delete fw-normal text-primary"></i></a>
                                                </td>
                                            </tr>
                                            )
                                        })}
                                        <tr>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row justify-content-end mt-6">
                            <div className="col-sm-6 text-right">
                                <a href="/cost_centers" className="btn btn-lg btn-secondary">
                                    {lang.get('messages.cancelar')}
                                </a>
                                <button id="btnPublish" type="button" className="btn btn-lg btn-primary ml-4">
                                    {lang.get('messages.guardar')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default CostCenterEditForm;

if (document.getElementById('CostCenterEditForm')) {
    ReactDOM.render(<CostCenterEditForm />, document.getElementById('CostCenterEditForm'));
}
